/**
 * The expiration time for invalidated items
 * @constant {number}
 */
export const EXP_INVALIDATED = -1;
export const DEFAULT_LIMIT = 10;



// WEBPACK FOOTER //
// ./d:/dbs/el/aapusc/private/client-universal/packages/time-aware-cache/src/constants.es